module.exports = __webpack_public_path__ + "img/phoneImg1.450e0301.jpg";